import React from 'react';
import { AlertsList } from './alerts-list';
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

export function AlertsMain() {
  const isSmall = useIsSmallScreen();

  return (
    <div
      style={{
        margin: isSmall ? '0px' : '10px 4px',
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'stretch',
      }}
    >
      <AlertsList />
    </div>
  );
}
